import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "_mt-4",
  "data-qa": "order-summary-wrapper"
}
const _hoisted_2 = { class: "gfu-heading gfu-heading--top-divider _mb-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_summary_list = _resolveComponent("base-summary-list")
  const _component_skeleton_base_summary_list = _resolveComponent("skeleton-base-summary-list")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.hasOrderDetails)
      ? (_openBlock(), _createBlock(_component_base_summary_list, {
          key: 0,
          "summary-list-data": $options.summaryListModel
        }, {
          header: _withCtx(() => [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.Resources.YourPledge.OrderSummaryHeader), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["summary-list-data"]))
      : (_openBlock(), _createBlock(_component_skeleton_base_summary_list, {
          key: 1,
          "items-count": 5
        }))
  ]))
}